import { useCallback, useEffect, useRef, useState, } from 'react';
import moment from 'moment';
export const Timer = ({ timeout, onComplete, }) => {
    const [currentTime, setCurrentTime] = useState(Date.now());
    const timerRef = useRef(null);
    const clockRef = useRef(null);
    const expirationRef = useRef(Date.now() + timeout);
    const clearTimers = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        if (clockRef.current) {
            clearInterval(clockRef.current);
            clockRef.current = null;
        }
    }, []);
    const updateClock = useCallback(() => {
        setCurrentTime(Date.now());
    }, []);
    useEffect(() => {
        expirationRef.current = Date.now() + timeout;
        setCurrentTime(Date.now());
        timerRef.current = setTimeout(onComplete, timeout);
        clockRef.current = setInterval(updateClock, 1000);
        return () => {
            clearTimers();
        };
    }, [timeout, onComplete, updateClock, clearTimers]);
    const remainingMilliseconds = Math.ceil(expirationRef.current - currentTime);
    const validRemainingMs = Math.max(0, remainingMilliseconds);
    return moment()
        .startOf('day')
        .milliseconds(validRemainingMs)
        .format('m:ss');
};
Timer.displayName = 'Timer';
export default Timer;
